import { Link } from "react-router-dom";

export function TicketsModulePlaceholder() {
  return (
    <section className="card">
      <h3 className="page-title" style={{ fontSize: "1.05rem" }}>
        Chamados
      </h3>
      <p className="section-description">
        Inbox de chamados abertos pelos usuários no CRM (todas as empresas).
      </p>
      <Link
        className="primary-button"
        to="/suporte/chamados"
        style={{ display: "inline-block", marginTop: 12, textDecoration: "none" }}
      >
        Abrir inbox
      </Link>
    </section>
  );
}
